import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_ASSIGNEE, GET_ASSIGNEE_SUCCESS, GET_ASSIGNEE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getAssignee({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/assignees`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_ASSIGNEE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_ASSIGNEE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_ASSIGNEE_ERROR, payload: error });
  }
}

export function* watchGetAssignee() {
  yield takeEvery(GET_ASSIGNEE, getAssignee);
}

function* getAssigneeSaga() {
  yield all([fork(watchGetAssignee)]);
}

export default getAssigneeSaga;